import { useState, useMemo } from 'react'
import {
    AnalyticsTableRowTypeChannels,
    AnalyticsTableRowTypeSites,
} from '../types'

export const useSearch = <
    T extends AnalyticsTableRowTypeSites | AnalyticsTableRowTypeChannels,
>(
    data: T[]
) => {
    const [searchQuery, setSearchQuery] = useState('')

    const filteredData = useMemo(() => {
        if (!searchQuery) return data
        return data.filter((item) => {
            const nameMatch =
                item.name &&
                item.name.toLowerCase().includes(searchQuery.toLowerCase())
            const budgetMatch =
                item.budget && item.budget.toString().includes(searchQuery)
            const dateMatch =
                item.creationDate &&
                new Date(item.creationDate)
                    .toLocaleDateString('ru-RU')
                    .includes(searchQuery)
            return nameMatch || budgetMatch || dateMatch
        })
    }, [data, searchQuery])

    return { searchQuery, setSearchQuery, filteredData }
}

export type UseSearch<
    T extends AnalyticsTableRowTypeSites | AnalyticsTableRowTypeChannels,
> = ReturnType<typeof useSearch<T>>
